import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { reactive, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import useFavorite from "../composables/useFavorite";
import SelectFavorite from "./SelectFavorite.vue";
import { srcType } from "@/utils/srcType";
import apis from "@/api";
import { SuccessFilled } from '@element-plus/icons-vue';
export default {
  emits: ['batchUpdate', 'selectChange'],
  components: {
    SuccessFilled,
    SelectFavorite
  },
  props: {
    assetsList: {
      type: Array,
      required: true
    },
    accessType: {
      type: String
    }
  },
  setup(props, ctx) {
    const selectFavoriteRef = ref({});
    const data = reactive({
      choseAsset: {},
      srcType: srcType
    });
    const {
      unFavorite
    } = useFavorite();
    const favHandler = i => {
      if (i.favorite) {
        // 取消收藏
        unFavorite(i.id).then(() => {
          i.favorite = false;
          ElMessage.success("已取消收藏");
        });
      } else {
        // 收藏
        data.choseAsset = i;
        selectFavoriteRef.value.visible();
      }
    };
    const favorited = p => {
      data.choseAsset.favorite = true;
      ElMessage.success("收藏成功");
    };
    const router = useRouter();
    const showDetail = i => {
      // 新建印刷品制作需求时 不跳转显示详情
      if ('addPrinted' === props.accessType) {
        return;
      }
      if (i.srcTyp !== "7") {
        router.push(`/assets-lib/detail/${i.id}`);
      } else {
        router.push(`/assets-lib/detail-sms/${i.id}`);
      }
    };
    const selectChange = item => {
      ctx.emit('selectChange', item);
    };
    const batchUpdateAssetsStatus = (status, ids) => {
      if (ids.length == 0) {
        ElMessage.warning("请先选择需要更新状态的素材！");
        return;
      }
      const params = {
        ids: ids.join(","),
        status: status
      };
      apis.batchUpdateAssetsStatus(params).then(res => {
        if (res.success) {
          setTimeout(function () {
            ElMessage.success("素材状态更新成功！");
            ctx.emit("batchUpdate");
          }, 1000); // ES更新索引存在几百毫秒的延时
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    return {
      ...toRefs(data),
      selectFavoriteRef,
      favHandler,
      showDetail,
      favorited,
      srcType,
      selectChange,
      batchUpdateAssetsStatus
    };
  }
};